import gsap from 'gsap';

export function menuMobile() {
    let hamburger  = document.querySelector('.hamburger-wrap');
    let wrapNav = document.querySelector('.main-nav-mobile');
    let mobile_wrap = document.querySelector('#wrap-mobile-menu');
    let sottoMenuMobile = document.querySelectorAll('#wrap-mobile-menu .main-menu > li.item');


    sottoMenuMobile.forEach((ele) => {
        if(ele.children[1] && ele.children[1].classList.contains('sub-menu')) {
            //console.log(ele.children[1].classList);
            ele.children[0].addEventListener('click', (r) => {
                r.preventDefault();
                r.stopPropagation();
                let subMenu = ele.children[1];
                if (subMenu.classList.contains('open')) {
                    gsap.to(subMenu, {
                        height: 0, // Anima l'altezza a 0 per nasconderlo
                        duration: 0.5, // Durata di 0.5 secondi
                        ease: "power2.inOut", // Ease per un'animazione più fluida
                        onComplete: () => {
                            subMenu.classList.remove('open'); // Rimuove la classe open dopo l'animazione
                        }
                    });
                } else {
                    // Se è chiuso, lo apriamo con un'animazione GSAP
                    subMenu.classList.add('open'); // Aggiungiamo la classe 'open'
                    gsap.fromTo(subMenu,
                        { height: 0 }, // Partiamo da altezza 0
                        {
                            height: "auto", // Espandiamo fino alla sua altezza naturale
                            duration: 0.5,
                            ease: "power2.inOut"
                    });
                }
            })
        }
    })


    hamburger.addEventListener("click", () => {
        wrapNav.classList.toggle('open');
        mobile_wrap.classList.toggle('nascondi');
        if(mobile_wrap.classList.contains('nascondi')){
            gsap.to(mobile_wrap, { height: 0, duration: 0.5, ease: "power2.inOut" });
        } else {
            gsap.to(mobile_wrap, { height: "100vh", duration: 0.5, ease: "power2.inOut" });
        }
    })
}

export function chiudiMenu(){
    let wrapNav = document.querySelector('.main-nav-mobile');
    let mobile_wrap = document.querySelector('#wrap-mobile-menu');
    if (window.innerWidth < 812) {
        wrapNav.classList.toggle('open');
        mobile_wrap.classList.toggle('nascondi');
        if(mobile_wrap.classList.contains('nascondi')){
            gsap.to(mobile_wrap, { height: 0, duration: 0.5, ease: "power2.inOut" });
        } else {
            gsap.to(mobile_wrap, { height: "100vh", duration: 0.5, ease: "power2.inOut" });
        }
    }

}